export default __webpack_public_path__ + "static/media/mariog8.4d08f845.jpg";